async function updateSmartCartSellingPlansScript() {
  try {
    const response = await fetch('/?section_id=smart-cart');
    const html = await response.text();

    const temp = document.createElement('div');
    temp.innerHTML = html;

    const newScript = temp.querySelector('#SmartCartItemsSellingPlans');
    if (!newScript) {
      console.warn('Nie znaleziono zaktualizowanego SmartCartItemsSellingPlans');
      return;
    }

    const targetScript = document.getElementById('SmartCartItemsSellingPlans');
    if (!targetScript) {
      console.warn('Nie znaleziono istniejącego SmartCartItemsSellingPlans w DOM');
      return;
    }

    const clonedScript = newScript.cloneNode(true);
    targetScript.replaceWith(clonedScript);
  } catch (err) {
    console.error('Błąd przy aktualizacji SmartCartItemsSellingPlans:', err);
  }
}

const handleGetItemsSellingPlans = () => {
  const smartCartPlans = getSmartCartPlans();
  const subItems = getSubscriptionItemsFromCart();

  subItems.forEach(async (cartItem) => {
    const wrapper = getCartItemWrapper(cartItem);
    if (!wrapper) return;

    const selectTarget = wrapper.querySelector('.rebuy-cart__flyout-item-subscription--select');
    if (!selectTarget) return;

    const matchedPlanData = findMatchedPlanData(cartItem.variant_id, smartCartPlans);

    if (!matchedPlanData) return;

    const select = await buildSellingPlanSelect(cartItem, matchedPlanData, selectTarget);
    selectTarget.innerHTML = '';
    selectTarget.appendChild(select);
  });
};

const getSmartCartPlans = () => {
  const el = document.getElementById('SmartCartItemsSellingPlans');
  if (!el) return [];
  try {
    return JSON.parse(el.textContent);
  } catch {
    console.warn('Nie udało się sparsować SmartCartItemsSellingPlans');
    return [];
  }
};

const getSubscriptionItemsFromCart = () =>
  Rebuy.SmartCart.cart.items.filter((item) => item.selling_plan_allocation?.selling_plan);

const getCartItemWrapper = (cartItem) => {
  return document.querySelector(
    `[data-variant="${cartItem.variant_id}"][data-item-key="${cartItem.key}"][data-has-sub="true"]`
  );
};

const findMatchedPlanData = (variantId, plans) => plans.find((item) => item.variant_id === variantId);

const buildSellingPlanSelect = async (cartItem, matchedPlanData, selectTarget) => {
  const selectedPlanId = cartItem.selling_plan_allocation?.selling_plan?.id || null;
  const availablePlans = matchedPlanData.available_selling_plans || [];

  const select = document.createElement('select');
  select.className = 'rebuy-select muted';
  select.dataset.variantId = cartItem.variant_id;
  select.dataset.productKey = cartItem.key;

  await addSubscriptionOptions(select, availablePlans, selectedPlanId, matchedPlanData, cartItem);

  select.addEventListener('change', (e) => handlePlanChange(e, selectTarget));

  return select;
};

const addSubscriptionOptions = async (select, availablePlans, selectedPlanId, matchedPlanData, cartItem) => {
  let hasSelectedMatch = false;

  availablePlans.forEach((plan) => {
    const option = document.createElement('option');
    option.value = plan.id;
    option.textContent = plan.name;

    if (Number(plan.id) === Number(selectedPlanId)) {
      option.selected = true;
      hasSelectedMatch = true;
    }

    select.appendChild(option);
  });

  if (!hasSelectedMatch && availablePlans.length > 1) {
    const matchedByPartial = matchPlanByName(matchedPlanData, availablePlans);
    if (matchedByPartial) {
      await updateCartItemSellingPlan(cartItem, matchedByPartial.id);
      const optionToSelect = select.querySelector(`option[value="${matchedByPartial.id}"]`);
      if (optionToSelect) optionToSelect.selected = true;
    } else if (select.children[1]) {
      select.children[1].selected = true;
      console.log('Brak match po nazwie — domyślnie zaznaczono drugi plan');
    }
  }
};

const matchPlanByName = (matchedPlanData, availablePlans) => {
  const target = matchedPlanData.selected_selling_plan_name?.trim();
  const partial = target?.match(/Dostawa co \d+/)?.[0];
  if (partial) {
    return availablePlans.find((plan) => plan.name.includes(partial));
  }
  return null;
};

const handlePlanChange = async (e, selectTarget) => {
  const newPlanId = e.target.value;
  const itemKey = e.target.dataset.productKey;

  const cart = Rebuy.SmartCart.cart;
  const item = cart.items.find((i) => String(i.key) === String(itemKey));
  if (!item) return console.warn('Nie znaleziono itemu:', itemKey);

  await updateCartItemSellingPlan(item, newPlanId);
};

const updateCartItemSellingPlan = async (cartItem, sellingPlanId) => {
  try {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        id: cartItem.key,
        quantity: cartItem.quantity,
        selling_plan: Number(sellingPlanId),
      }),
    });

    await Rebuy.Cart.fetchCart();
  } catch (err) {
    console.error('Błąd aktualizacji planu:', err);
  }
};

// document.addEventListener('rebuy:cart.ready', () => {
//   setTimeout(() => {
//     updateSmartCartSellingPlansScript().then(() => {
//       handleGetItemsSellingPlans();
//     });
//   }, 200);
// });
//
// document.addEventListener('rebuy:cart.change', () => {
//   setTimeout(() => {
//     updateSmartCartSellingPlansScript().then(() => {
//       handleGetItemsSellingPlans();
//     });
//   }, 200);
// });
